import { graphql, DataValue } from '@apollo/client/react/hoc';
import * as React from 'react';
import { memoize } from 'lodash';
import { addSequenceItemsToQueryResult } from '../utils/query';
import GET_CHAT_STREAM_ITEMS_QUERY from '../queries/GetChatStreamItems.gql';
import type {
  GetChatStreamItems as GetChatStreamItemsData,
  GetChatStreamItems_chatStreams,
  GetChatStreamItems_chatStreams_sequenceItems,
} from '../queries/__generated__/GetChatStreamItems';
import type { ApolloError } from 'apollo-server-errors';

export const FIRST_PAGE_VAR = {
  gapItemNextPageParams: '{"limit":20,"since_seq":0}',
};

export type ChatStreamContainerChildrenProps = {
  loadGaps: (gaps: Array<GetChatStreamItems_chatStreams_sequenceItems>) => void;
  error: ApolloError;
  stream: GetChatStreamItems_chatStreams | null;
  loading: boolean;
};

type Props = {
  data?: DataValue<GetChatStreamItemsData>;
  uuid: string;
  children: (childProps: ChatStreamContainerChildrenProps) => React.ReactElement;
  onNewBottomItem: () => void;
};

class ChatStreamContainer extends React.Component<Props, {}> {
  componentDidUpdate(prevProps: Props) {
    const curr = this.getSequenceItems(this.props);
    const prev = this.getSequenceItems(prevProps);

    if (curr[0] !== prev[0]) {
      this.props.onNewBottomItem();
    }
  }

  isLoading = (props: Props): boolean => {
    return props.data?.loading || (props.data?.networkStatus ?? 7) < 7;
  };

  getSequenceItems = (props: Props): Array<GetChatStreamItems_chatStreams_sequenceItems> => {
    const stream = this.getStream(props);

    if (stream && stream.uuid === this.props.uuid) {
      return stream.sequenceItems ? [...stream.sequenceItems] : [];
    } else {
      return [];
    }
  };

  getStream = (props: Props): GetChatStreamItems_chatStreams | null => {
    const stream = props.data?.chatStreams?.[0];

    if (stream && stream.uuid === this.props.uuid) {
      return stream;
    } else {
      return null;
    }
  };

  loadGaps = (gaps: Array<GetChatStreamItems_chatStreams_sequenceItems>) => {
    for (const gap of gaps) {
      // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
      this.loadGap(gap);
    }
  };

  // memoize this function to avoid reloading a gap multiple time
  // when switching between chats.
  // @ts-expect-error ts-migrate(2558) FIXME: Expected 1 type arguments, but got 2.
  loadGap = memoize<Array<GetChatStreamItems_chatStreams_sequenceItems>, void>(
    (gap: GetChatStreamItems_chatStreams_sequenceItems) => {
      const { uuid } = this.props;
      const gapItemNextPageParams =
        gap.item.__typename === 'GapItem' ? gap.item.nextPageParams : undefined;

      this.props.data
        ?.fetchMore({
          variables: { uuid, gapItemNextPageParams },
          updateQuery: (previous, { fetchMoreResult }) => {
            if (!fetchMoreResult) {
              return previous;
            }

            return addSequenceItemsToQueryResult(
              previous,
              // @ts-expect-error
              fetchMoreResult.chatStreams[0].sequenceItems
            );
          },
        })
        .catch((e: any) => console.error('could not load chat gap message:', e));
    }
  );

  render() {
    return this.props.children({
      loadGaps: this.loadGaps,
      // @ts-expect-error
      error: this.props.data.error,
      stream: this.getStream(this.props),
      loading: this.isLoading(this.props),
    });
  }
}

const WithMessages = graphql(GET_CHAT_STREAM_ITEMS_QUERY, {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'uuid' does not exist on type '{}'.
  options: ({ uuid }) => ({
    notifyOnNetworkStatusChange: true,
    variables: {
      uuid,
      ...FIRST_PAGE_VAR,
    },
  }),
});

export { ChatStreamContainer };
// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof ChatStreamContainer' is n... Remove this comment to see the full error message
export default WithMessages(ChatStreamContainer);
